import { GridToolbarContainer, GridToolbarDensitySelector } from "@mui/x-data-grid";
import { colors } from "../../theme/Colors";

export function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ "& .MuiButton-root": { color: colors.mj_navbar } }}>
      <GridToolbarDensitySelector sx={{ "& .MuiButton-startIcon": { color: colors.mj_navbar } }} />
    </GridToolbarContainer>
  );
}
